var mouseButtons = Object.freeze({
   mainButton: 0,
   auxiliaryButton: 1,
   secondaryButton: 2
});

export default mouseButtons;
